import { Table } from 'antd';
import ReactToPrint from 'react-to-print';

const MyTable = ( { columns, dataSource, printElements, ref } ) => {
    const splitTable = () => {
        const maxItem = 20;
        const len = dataSource.length;

        const tables = [];
        if(len>maxItem) {
            let index = 0;
            while(index<len){
                tables.push(
                    <div key={index}>
                    {printElements.header('Catálogo Ecolistico')}
                    <Table 
                        bordered={true} 
                        size={'small'} 
                        pagination={false} 
                        columns={columns}
                        dataSource={dataSource.slice(index, index + maxItem)}/>;
                    {printElements.date}
                    {printElements.advertise}
                    </div>
                );
                index += maxItem;
            }
        }
        else {
            tables.push(
                <div key={1}>
                {printElements.header('Catálogo Ecolistico')}
                <Table 
                    bordered={true} 
                    size={'small'} 
                    pagination={false} 
                    columns={columns}
                    dataSource={dataSource}/>;
                {printElements.date}
                {printElements.advertise}
                </div>
            );
        }
        return tables;
    };

    return (
    <>
        <div style={{ overflow: 'hidden', height: 0 }} >
            <div ref={ref}>
                {splitTable()}
            </div>
        </div>
        {printElements.header('Catálogo')}
        <Table 
            bordered={true} 
            size={'small'} 
            pagination={false} 
            columns={columns} 
            dataSource={dataSource} 
            scroll={{ x: 'max-content', y: '50vh' }}/>
        {printElements.date}
        {printElements.advertise}
        <ReactToPrint
                trigger={() => printElements.triggerPrint()}
                content={() => ref.current}
                onBeforeGetContent={printElements.handleBeforeGetContent}
                onAfterPrint={printElements.handleAfterPrint}
                documentTitle={'catalogo_tabla'}
        />
    </>
)};

export default MyTable;